/**
 * Синтетический id группы «одиночных» модификаторов продукта.
 *
 * Группа с этим id не приходит с бэка как отдельная сущность — она создаётся на лету
 * (через `unshift`) при инициализации модификаторов карточки/комбо, чтобы положить
 * плоский список `product.modifiers` в ту же структуру `group_modifiers`.
 *
 * Исторически по коду строка была захардкожена в ~20 местах; здесь она централизована.
 */
export const SINGLE_MODIFIERS_GROUP_ID = "Добавки2000";

/** Отображаемое имя синтетической группы одиночных модификаторов. */
export const SINGLE_MODIFIERS_GROUP_NAME = "Добавки";
